'use strict';

bbw.directive.bbwSmileySelectorDesktop = ['$timeout', 'bbw.SmileySvc', function($timeout, smileySvc) {

    var smileysCollection = smileySvc.getSmileysCollection();

    return {
        scope: {
            'ctrl': '=bbwSmileySelectorDesktop'
        },
        transclude: true,
        templateUrl: bbw.templateUrl('smiley-selector-desktop.html'),
        link: function(scope, element) {
            var elSelectionBox = element[0].querySelector('.smiley-selector');
            if (!elSelectionBox) {
                throw new Error('.smiley-selector element not found');
            }

            var elClickToggle = element[0].querySelector('.smiley-toggle');
            if (!elClickToggle) {
                throw new Error('.smiley-toggle element not found');
            }

            elSelectionBox.style.display = 'none';

            var selectionBoxIsVisible = false;
            var hideTimeout = undefined;
            var mouseIsOver = [false, false];

            function toggle(hide) {
                if (hide || selectionBoxIsVisible) {
                    elSelectionBox.style.display = 'none';
                    selectionBoxIsVisible = false;
                } else {
                    elSelectionBox.style.display = 'block';
                    selectionBoxIsVisible = true;
                }
                cancelHideTimeout();
            }

            function show() {
                if (!selectionBoxIsVisible) {
                    toggle();
                }
            }

            function cancelHideTimeout() {
                if (hideTimeout) {
                    $timeout.cancel(hideTimeout);
                    hideTimeout = undefined;
                }
            }

            function setHideTimeout() {
                cancelHideTimeout();
                hideTimeout = $timeout(toggle.bind(null, true), 750);
            }

            function isMouseOver() {
                return mouseIsOver.some(function(value) {
                    return value;
                });
            }

            function setMouseOver(index, value) {
                mouseIsOver[index] = !!value;
                return isMouseOver();
            }

            scope.$on('$destroy', cancelHideTimeout);

            [angular.element(elSelectionBox), angular.element(elClickToggle)].forEach(function(element, index) {
                element.bind('mouseleave', function(index) {
                    setMouseOver(index, false) ? cancelHideTimeout() : (selectionBoxIsVisible && setHideTimeout());
                }.bind(null, index));
                element.bind('mouseover', function(index) {
                    setMouseOver(index, true);
                    cancelHideTimeout();
                }.bind(null, index));
            });

            angular.element(elClickToggle).on('mousedown', function(e) {
                e.preventDefault();
                e.stopPropagation();
                toggle();
                return false;
            });

            angular.element(elClickToggle).on('mouseenter', show);

            if (bbw.browser.msie && bbw.browser.version < 11) {
                element.parent().on('mouseenter', show);
            }

            scope.smileys = smileysCollection;
            scope.toggle = toggle;

            scope.select = function(name) {
                scope.ctrl.insertSmiley(name);
                return false;
            };
        }
    }

}];
